import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import DashboardCard from './DashboardCard';
import { BRAND } from '../styles';
import { formatHours, formatNumber } from '../constants';

// Kart 3/7 — Aşamada geçen süre: aşama başına MEDYAN saat (brief: "Başlıkta
// 'medyan' yaz — kullanıcı ortalama sanmasın"). Başlık metni
// atsDashboard.stageDuration.title çeviri anahtarından gelir; o anahtarın
// değeri "medyan"/"median" kelimesini İÇERMELİDİR (bkz. rapor).

const TooltipBox = styled.div`
  background: #fff;
  border: 1px solid ${BRAND.border};
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  box-shadow: 0 4px 16px rgba(0, 66, 66, 0.12);
`;

const TooltipTitle = styled.div`
  font-weight: 700;
  color: ${BRAND.textDark};
  margin-bottom: 4px;
`;

const TooltipRow = styled.div`
  color: #6B7280;
`;

function StageTooltip({ active, payload, t, locale }) {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <TooltipBox>
      <TooltipTitle>{row.stageName}</TooltipTitle>
      <TooltipRow>{t('atsDashboard.stageDuration.medianTooltip', { value: formatHours(row.medianHours, locale) })}</TooltipRow>
      <TooltipRow>{t('atsDashboard.stageDuration.p75Tooltip', { value: formatHours(row.p75Hours, locale) })}</TooltipRow>
      <TooltipRow>{t('atsDashboard.stageDuration.transitionsTooltip', { count: formatNumber(row.transitions, locale) })}</TooltipRow>
    </TooltipBox>
  );
}

export default function StageDurationCard({ data, loading }) {
  const { t, i18n } = useTranslation();

  const rows = useMemo(() => (
    [...(data || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
  ), [data]);

  return (
    <DashboardCard
      cardKey="asamada-gecen-sure-medyan"
      title={t('atsDashboard.stageDuration.title')}
      meta={t('atsDashboard.stageDuration.meta')}
      span={5}
      spanMd={6}
      loading={loading}
      empty={rows.length === 0}
      domId="ats-dash-stage-duration"
    >
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={rows} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
          <XAxis
            dataKey="stageName"
            tickLine={false}
            axisLine={{ stroke: BRAND.border }}
            tick={{ fontSize: 10, fill: '#6B7280' }}
            interval={0}
            angle={-20}
            textAnchor="end"
            height={48}
          />
          <YAxis hide />
          <Tooltip content={<StageTooltip t={t} locale={i18n.language} />} cursor={{ fill: 'rgba(2, 211, 191, 0.06)' }} />
          <Bar dataKey="medianHours" fill={BRAND.primary} barSize={28} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
